/**
 * Creates a duplicate-free version of an array,
 * it accepts comparator which is invoked to compare elements of array
 *
 * @template T
 * @param {Array<T>} array
 * @param {Function} comparator
 * @return {Array<T>} unique array
 *
 * @example
 * uniqWith(
 * [{ x: 1, y: 2 }, { x: 1, y: 3 }, { x: 2, y: 4 }, { x: 1, y: 2 }],
 * (arrayValue, otherValue) => arrayValue.x === otherValue.x
 * );
 * // returns [{ x: 1, y: 2 }, { x: 2, y: 4 }]
 *
 */
export var uniqWith = function (array, comparator) {
    var result = [];
    var i;
    array.forEach(function (item) {
        i = result.findIndex(function (itemInResult) { return comparator(item, itemInResult); });
        if (i === -1) {
            result.push(item);
        }
    });
    return result;
};
//# sourceMappingURL=uniqWith.js.map